import { isReviewItemResolved } from "@utils/reportVisibility";

import {
  ApiReportSectionFieldsFieldTypeChoices,
  ReportSectionFieldsType,
  ReviewItemFieldsFragment,
} from "@api/graphql/types-and-hooks";
import { fitsCurrentOptions, isSameValue } from "@components/QaReview/PeerReview/peerReview.readableValue";

export interface PeerReviewField {
  id: string;
  sectionId: string;
  title: string;
  content: string;
  realField: ReportSectionFieldsType;
}

/** A Team Review comment carrying an edit the author can accept. */
export const isSuggestedEdit = (item: ReviewItemFieldsFragment) =>
  item.__typename === "ReportCommentType" && item.baseValue != null && item.proposedValue != null;

export const isConflicting = (item: ReviewItemFieldsFragment, fieldsById: Record<string, PeerReviewField>): boolean => {
  if (item.__typename !== "ReportCommentType" || item.baseValue == null || isReviewItemResolved(item)) return false;
  const fieldId = item.reportSectionField?.id;
  const field = fieldId ? fieldsById[fieldId] : undefined;
  const fieldType = field?.realField.fieldType;
  const currentValue = field?.content ?? "";
  const proposedValue = item.proposedValue ?? "";
  if (isSameValue(fieldType, proposedValue, currentValue)) return false;
  // A suggested answer the field no longer offers would overwrite its options, so that is a conflict too.
  return (
    !isSameValue(fieldType, item.baseValue, currentValue) || !fitsCurrentOptions(fieldType, currentValue, proposedValue)
  );
};

// Tables, signatures and images need richer values than the dialog and inline diff can show.
const EDIT_SUGGESTABLE_FIELD_TYPES = new Set<ApiReportSectionFieldsFieldTypeChoices>([
  ApiReportSectionFieldsFieldTypeChoices.SimpleText,
  ApiReportSectionFieldsFieldTypeChoices.Wysiwyg,
  ApiReportSectionFieldsFieldTypeChoices.Date,
  ApiReportSectionFieldsFieldTypeChoices.Datetime,
  ApiReportSectionFieldsFieldTypeChoices.Select,
  ApiReportSectionFieldsFieldTypeChoices.Radio,
  ApiReportSectionFieldsFieldTypeChoices.Checkbox,
]);

export const isEditSuggestableFieldType = (fieldType: ApiReportSectionFieldsFieldTypeChoices): boolean =>
  EDIT_SUGGESTABLE_FIELD_TYPES.has(fieldType);
